
<!--banner starts-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/1.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Web Design and Development</h1></div>
                    <div>
                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">We give proficient web design and development services to manage all phases of your business. We give your business a competing end with convenient and interactive web applications.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>       
<!--banner ends-->
    <div class="uk-section uk-padding" style=" padding-bottom: 0px;">
        <div class="uk-container">
          
            <h2 class="uk-text-center">Design And Development</h2>
            <br>
            <div class="uk-column-1-2@s">
      
                  
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">A website is the face
                     of any brand. The business website development is the creation of completely connecting
                      web details with proper graphics. With powerful interface design, regulated code, and
                       efficient user experience, we give affordable website design. Also, by connecting an
                        active SEO (Search Engine Optimization) property benefits in greater Return on
                         Investment (ROI) results. We are a productive and expert website design company
                          supporting our clients to improve their business concepts and keep their brand 
                          value.</p>
                     <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Our business website
                         development squad assures that the site carries significant and proper information.
                          Our affordable website design solutions are manageable, scalable, clear, and fully
                           customizable. As a reliable expert web design company, we give good content and
                            beautiful graphic design, promoting your website to get a great hike in its 
                            influence. Our squad delivers the best web design and development services. </p>
                <img data-src="assets/webdesgin2.png" width="700" height="700" alt="" uk-img>
    
            </div>
            <br>
        </div>
    </div>
    <div class="uk-section-1 uk-section-default">
        <div class="uk-container uk-container-expand" style="padding-bottom: 20px;">
    
            <h1 class="uk-padding-small">What Makes Us Special</h1>
        <div class="uk-column-1-2@s uk-margin-medium">
            
            <ul class="uk-list uk-list-disc uk-text-medium uk-text-justify" style="font-size: 18px; color:#fff;">
                <li>We transform the latest technologies and promote our standing projects.  </li>
                <li>We maintain everything from the user interface to memory and power managing in the 
                    sense while creating web apps. </li>
                <li>We are experts in E-commerce website development services. </li>
                <li>We don’t compromise on our integrity and credibility.</li>
                
                <li>Our web solutions are liked by our clients, users and tech enthusiasts. </li>
                <li>The credibility of our web apps is improving every day.</li>
             
                <li> We take care of the app from creating, uploading to the app store and updating the apps. </li>
                
            </ul>      
    </div>
    </div>
    </div>
        <div class="uk-section-1 uk-section-default">
            <div class="uk-container uk-container-expand">
        
                
        
        </div>
        <h1 class="uk-text-center">Related Services</h1>
        <br>
       <div class="uk-container">
    <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;" >
            
                <img class=" uk-align-center" src="../../assets/icons/cbg11.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Custom Business<br> Application</h4>
        
            </div>
        </div>
    

        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-align-center" src="../../assets/icons/phpg5.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Php Application<br> Development</h4>

        
            </div>
        </div>


        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/laravelg6.png" width="100" height="100"
                    alt="">
                <h4 class="uk-text-center" style="font-weight: 600; ">Laravel Application<br>Development</h4>
            </div>
        
        </div>
    

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/webdeg.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="font-weight: 600; ">Web Application <br>Development</h4>
            </div>
        </div>

        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/pythong4.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Python <br>Programming </h4>

        
            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/shopifyg7.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Ecommerce Web <br>Development</h4>

        
            </div>
        </div>

    
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/webdesigng12.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style= "font-weight: 600;">Web Design <br>And Development</h4>

            </div>
        </div>
       
    </div>

</div>
        </div>
        <br>
        <br>

<!--Technology stack part code-->
<br>
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-4@s uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">WordPress</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Angular js</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Postgres SQL</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Html</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">CSS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Redis.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600">Redis</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600" >JavaScript</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/jest.png" style="width:90px; height:90px"
                    alt="border-circle">
                <h4 style="font-weight:600">Jest</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Redux</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Ruby_logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Ruby On Rails</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600" >AWS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">Nginx</h4>
            </div>
        </div>
    </div>
</div>
<br>
<!--Technology stack part code end-->

<br>